import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202601",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 12586,
  clicks: 201,
  adsSpendDollars: 1283,
  budgetDollars: 1500,
  salesDollars: 27388,
  bestEstimateRoas: 21.35,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.86,
  newCustomersAcquired: 9,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
